// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2oGNx","inner":"Form_inner__3TB2P","range":"Form_range__1BSnF","name":"Form_name__10VZt","actions":"Form_actions__1Hhm7"};